import {NgModule} from "@angular/core";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {BrowserModule} from "@angular/platform-browser";
import {BootstrapModalModule} from "../bootstrap-modal/bootstrap-modal.module";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {EditAssetDialogComponent} from "./edit-asset-dialog.component";
import {EditRemovalAssetDialogComponent} from "./edit-removal-asset-dialog.component";
import {EditAssetComponent} from "./edit-asset.component";
import {EditSoftwareComponent} from "./edit-software.component";
import {EditAccessoryComponent} from "../accessory/edit-accessory.component";
import {AssetService} from "./asset.service";
import {AssetRemovalService} from "./asset-removal.service";
import {ErrorModule} from "../errors/error.module";
import {FormHelpersModule} from "../form-helpers/form-helpers.module";
import {ContactModule} from "../contact/contact.module";
import {MdProgressSpinnerModule} from "../misc/progress-spinner";
import {DatePickerModule} from "../datepicker/datepicker.module";
import {GraphqlCoreModule} from "../graphql/graphql-core.module";
import {AppSettingsModule} from "../app-settings/app-settings.module";
import {CostCentersListComponent} from "../cost-center/cost-centers-list.component";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import { NoCommaPipe } from './no-comma.pipe'

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    FormHelpersModule,
    BootstrapModalModule,
    ErrorModule,
    ReactiveFormsModule,
    ContactModule,
    MdProgressSpinnerModule,
    DatePickerModule,
    GraphqlCoreModule,
    AppSettingsModule,
    NgbModule,
  ],
  providers: [
    DialogService,
    AssetService,
    AssetRemovalService,
  ],
  declarations: [
    EditAssetDialogComponent,
    EditRemovalAssetDialogComponent,
    EditAssetComponent,
    EditSoftwareComponent,
    EditAccessoryComponent,
    CostCentersListComponent,
    NoCommaPipe
  ],
  exports: [
    EditAssetDialogComponent,
    EditRemovalAssetDialogComponent,
    EditAssetComponent,
    EditSoftwareComponent,
    EditAccessoryComponent,
  ],
  entryComponents: [
    EditAssetDialogComponent,
    EditRemovalAssetDialogComponent,
    EditAssetComponent,
    EditSoftwareComponent,
    EditAccessoryComponent,
  ],
})
export class AssetModule {}
